import { CustomFieldFilterType } from "./CustomFieldFilterUtils";
import { IconProps, LucideIcon } from "../../../common/icon/LucideIcon";
import { CustomFieldSearchOperator } from "../../../api/GenericTypes";
import { ReactComponent as InIcon } from "./OperatorIcons/in.svg";
import { ReactComponent as NotInIcon } from "./OperatorIcons/notin.svg";
import { ReactComponent as LessThanOrEqualIcon } from "./OperatorIcons/lessthanoreq.svg";
import { ReactComponent as StrContainsIcon } from "./OperatorIcons/strcontains.svg";
import { ReactComponent as StrNotContainsIcon } from "./OperatorIcons/strnotcontains.svg";
import { ReactComponent as GreaterThanOrEqualIcon } from "./OperatorIcons/greaterthanoreq.svg";
import { ReactComponent as StartsWithIcon } from "./OperatorIcons/startswith.svg";
import { ReactComponent as EndsWithIcon } from "./OperatorIcons/endswith.svg";
interface RenderCustomFieldFilterTypeProps extends Omit<IconProps, "name"> {
  type: CustomFieldFilterType;
}
export const RenderCustomFieldFilterType = ({ type, ...props }: RenderCustomFieldFilterTypeProps): JSX.Element => {
  switch (type) {
    case "flat":
      return <LucideIcon {...props} name="filter" />;
    case "tree":
      return <LucideIcon {...props} name="network" />;
    default:
      return <></>;
  }
};

interface RenderCustomFieldOperatorProps extends Omit<IconProps, "name"> {
  operator: CustomFieldSearchOperator;
}
export const RenderCustomFieldOperator = ({ operator, ...props }: RenderCustomFieldOperatorProps): JSX.Element => {
  switch (operator) {
    case "EQUALS":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <LucideIcon {...props} name="equal" />
        </div>
      );
    case "NOT_EQUALS":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <LucideIcon {...props} name="equal-not" />
        </div>
      );
    case "GREATER_THAN":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <LucideIcon {...props} name="chevron-right" />
        </div>
      );
    case "GREATER_THAN_OR_EQUAL":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <GreaterThanOrEqualIcon className="feather" {...props} />
        </div>
      );
    case "LESS_THAN":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <LucideIcon {...props} name="chevron-left" />
        </div>
      );
    case "LESS_THAN_OR_EQUAL":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <LessThanOrEqualIcon className="feather" {...props} />
        </div>
      );
    case "STRING_CONTAINS":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <StrContainsIcon className="feather" {...props} />
        </div>
      );
    case "STRING_NOT_CONTAINS":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <StrNotContainsIcon className="feather" {...props} />
        </div>
      );
    case "IN":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <InIcon className="feather" {...props} />
        </div>
      );
    case "NOT_IN":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <NotInIcon className="feather" {...props} />
        </div>
      );
    case "STARTS_WITH":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <StartsWithIcon className="feather" {...props} />
        </div>
      );
    case "ENDS_WITH":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <EndsWithIcon className="feather" {...props} />
        </div>
      );
    case "IS_NULL":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <LucideIcon {...props} name="circle-slash" />
        </div>
      );
    case "IS_NOT_NULL":
      return (
        <div className="flex" style={{ height: "min-content" }} title={operator}>
          <LucideIcon {...props} name="asterisk" />
        </div>
      );
    default:
      return <></>;
  }
};
